// @flow
import type { MessageRouter } from 'common/modules/notifications/domain/Message';
import { EstimationProgress } from 'statsradio/modules/sales/domain/estimationProgress';
import { updateProgress } from 'statsradio/modules/sales/actions/salesNotificationsActions';
import type { Dispatch } from '../../../types/Store';

export default class NotificationMessageRouter implements MessageRouter {
  dispatch: Dispatch;

  constructor(dispatch: Dispatch) {
    this.dispatch = dispatch;
  }

  route(type: string, data: Object) {
    if (type === 'SALES_PROGRESS') {
      const progress = EstimationProgress.parse(data);
      this.dispatch(updateProgress(progress));
    }
  }

  static create(dispatch: Dispatch): MessageRouter {
    return new NotificationMessageRouter(dispatch);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/notifications/actions/notificationRouter.js